// extracted by mini-css-extract-plugin
var _1 = "active-fields-section__WsRc6";
var _2 = "active-fields-section-limited-width__Xzge3";
var _3 = "disabled-fields-section__DW1ZM";
var _4 = "opt-in-switch-label__KtNZ1";
export { _1 as "activeFieldsSection", _2 as "activeFieldsSectionLimitedWidth", _3 as "disabledFieldsSection", _4 as "optInSwitchLabel" }
